import { useMutation, useQuery, useQueryClient } from "react-query";
import { MODAL_QUERY_NM } from "./modal";
import { instance } from ".";

const contextPath = '/auth';
export const AUTH_QUERY_NAME = 'AUTH_INFO';

const setLoacalStorage = (param) => {
    localStorage.setItem('TSS_AUTH_INFO',JSON.stringify(param.data));
}

export const getLocalStorage = () => {
    const temp = localStorage.getItem('TSS_AUTH_INFO');
    if(temp && temp.length > 0){
        return JSON.parse(temp);
    }
}

const removeLocalStorage = () => {
    localStorage.clear();
}

export const useLogin = (param) => {
    const queryClient = useQueryClient();
    return useMutation(
        (param) => login(param),
        {
            onSuccess: (res) => {
                removeLocalStorage();
                setLoacalStorage(res.data);
                queryClient.invalidateQueries([AUTH_QUERY_NAME], { refetchInactive: true })
            },
            onError: (err) => {
                queryClient.setQueryData([MODAL_QUERY_NM],{show:true,msg:err.response.data.data.msg})
            }
        }
    )
}

export const useLogout = (param) => {
    const queryClient = useQueryClient();
    return useMutation(
        () => {
            console.log('GOGOGO LOGOUT');
            removeLocalStorage();
            queryClient.invalidateQueries([AUTH_QUERY_NAME], { refetchInactive: true })
        }
    )
}

const login = async (param) => {
    return await instance.post(contextPath+'/login', param);
}

export const useGetAuthInfo = (param) => {
    return useQuery([AUTH_QUERY_NAME], ()=>getLocalStorage(),{initialData:getLocalStorage()});
}

export const authExpired = (queryClient) => {
    removeLocalStorage();
    queryClient.invalidateQueries([AUTH_QUERY_NAME], { refetchInactive: true });
    queryClient.setQueryData(['AUTH_ERR_INFO'], {status:401});
}